import React, { useRef, useState } from "react";
import Background from "../../assets/profile/back7.jpeg";
// import Profile from "../assets/home/dog.svg";
import Feed from "../../components/organisms/Feed";
import { useAppSelector } from "../../redux/ReduxType";
import CreatePost from "../../components/shared/CreatePost";
import { Link } from "react-router-dom";
import { USER_URL } from "../../constant/resource";
import { useFetchData } from "../../hooks/useFetchData";
import Modal from "../../components/organisms/modal/modal";
import FriendRequest from "./FriendRequest";
import { getUserProfile } from "./data";

interface IProfile {}

const Profile: React.FC<IProfile> = () => {
  const isDark = useAppSelector((state) => state.theme.isDark);
  // const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [activeSelection, setActiveSelection] = useState("post");
  const auth = useAppSelector((state) => state.user);
  const post = useAppSelector((state) => state.posts);
  const { data: userData, refetch } = useFetchData<any>(USER_URL);
  const [showRequest, setShowRequest] = useState(false);
  const profile = getUserProfile(userData);

  console.log("data -->", userData);
  const handleShowRequest = () => {
    setShowRequest((prev) => !prev);
  };

  const userPost = post?.posts?.filter(
    (eachPost: any) => eachPost?.author?._id === auth?._id
  );

  const handleSelection = (selection: string) => {
    setActiveSelection(selection);
  };

  return (
    <div
      className={`rounded-lg min-w-full shadow-sm overflow-auto custom-scrollbar ${
        isDark ? "bg-deepBg text-white" : "bg-white text-gray-900"
      }`}
    >
      {/* Profile Header */}
      <section className="relative w-full h-[240px] bg-gray-200 dark:bg-gray-700">
        <img
          className="object-cover w-full h-full"
          src={profile?.profile || Background}
          alt="Cover"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-gray-900/50 to-transparent h-1/2" />
        <div className="absolute bottom-0 left-6 transform translate-y-1/2 flex items-end gap-4">
          <img
            className="w-20 h-20 rounded-full object-cover border-4 border-white dark:border-gray-800 shadow-md"
            src={profile?.avatar}
            alt="Profile"
          />
          <div className="pb-4">
            <h2 className="text-2xl font-medium text-white">
              {profile?.fullName || "N/A"}
            </h2>
            <p className="text-sm text-gray-300">
              {profile?.username || "N/A"}
            </p>
          </div>
        </div>
      </section>

      {/* Profile Info */}
      {/* <section className="pt-16 sm:px-6 px-2 pb-6">
        <div
          className={`rounded-lg shadow-sm p-4 ${
            isDark ? "bg-darkBg text-gray-200" : "bg-gray-100 text-gray-700"
          }`}
        >
          <p className="text-sm font-medium">{profile?.profession || "N/A"}</p>
          <p className="text-xs mt-1">
            {profile?.state}, {profile?.country}
          </p>
          <p className="text-xs mt-1">
            {`${profile?.follower?.length || 0} follower`}
          </p>
          <button onClick={handleShowRequest} className="text-xs mt-1 block">
            {profile?.friendRequest?.length || 0}{" "}
            <span className="text-indigo-500">Friend Requests</span>
          </button>
          <Link
            to={`/update/${auth._id}?id=${auth._id}&email=${auth.email}&step=stepOne`}
            className="mt-3 px-4 py-2 w-fit rounded-md block bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700 shadow-sm hover:shadow-md transition-shadow duration-200"
          >
            Update Profile
          </Link>
        </div>
      </section> */}

      <section className="pt-16 sm:px-8 px-4 pb-8 max-w-4xl mx-auto">
        <div
          className={`rounded-xl shadow-md p-6 transition-all duration-200 ${
            isDark ? "bg-gray-800 text-gray-200" : "bg-white text-gray-700"
          }`}
        >
          <p className="text-base font-semibold">
            {profile?.profession || "N/A"}
          </p>
          <p className="text-sm mt-2">
            {profile?.state && profile?.country
              ? `${profile.state}, ${profile.country}`
              : "N/A"}
          </p>
          <p className="text-sm mt-2">
            {`${profile?.follower?.length || 0} follower${
              profile?.follower?.length !== 1 ? "s" : ""
            }`}
          </p>
          <button
            onClick={handleShowRequest}
            className="text-sm mt-2 flex items-center gap-1 hover:text-indigo-400 transition-colors duration-200"
          >
            {profile?.friendRequest?.length || 0}{" "}
            <span className="text-indigo-500 font-medium">Friend Requests</span>
          </button>
          <Link
            to={`/update/${auth._id}?id=${auth._id}&email=${auth.email}&step=stepOne`}
            className={`mt-4 px-5 py-2 rounded-full text-sm font-semibold inline-block transition-all duration-200 ${
              isDark
                ? "bg-indigo-600 text-white hover:bg-indigo-700 hover:shadow-lg"
                : "bg-indigo-500 text-white hover:bg-indigo-600 hover:shadow-lg"
            }`}
          >
            Update Profile
          </Link>
        </div>
      </section>

      <section className="pt-16 sm:px-6 px-2 pb-6">
        <h1>About</h1>
      </section>

      {/* Create Post */}
      <section className="sm:px-6 px-2 py-4">
        <CreatePost userId={auth._id} />
      </section>

      {/* Content Tabs */}
      <section className="sm:px-6 px-2 py-4">
        <div className="flex items-center justify-start gap-6 border-b border-gray-200 dark:border-gray-700 mb-6">
          {["post", "media", "comments"].map((tab) => (
            <button
              key={tab}
              onClick={() => handleSelection(tab)}
              className={`pb-2 text-sm font-medium capitalize ${
                activeSelection === tab
                  ? "border-b-2 border-indigo-500 text-indigo-500 dark:text-indigo-400"
                  : "text-gray-600 dark:text-gray-400 hover:text-indigo-500 dark:hover:text-indigo-400"
              } transition-colors duration-200`}
            >
              {tab}
            </button>
          ))}
        </div>
        <div>
          {activeSelection === "post" && userPost?.length ? (
            userPost.map((post: any) => (
              <Feed
                key={post._id}
                showAll={false}
                isDark={isDark}
                data={post}
              />
            ))
          ) : activeSelection === "post" ? (
            <p className="text-sm text-gray-500 dark:text-gray-400 text-center py-4">
              No posts yet
            </p>
          ) : null}
          {activeSelection === "media" && (
            <div className="py-4 text-sm text-gray-500 dark:text-gray-400 text-center">
              Media content coming soon
            </div>
          )}
          {activeSelection === "comments" && (
            <div className="py-4 text-sm text-gray-500 dark:text-gray-400 text-center">
              Comments content coming soon
            </div>
          )}
        </div>
      </section>
      <Modal showModal={showRequest} setShowModal={handleShowRequest}>
        <FriendRequest
          requests={userData?.friendRequest}
          // close={handleShowRequest}
          refetch={refetch}
        />
      </Modal>
    </div>
  );
};

export default Profile;
